namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class ListMenuEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
        }

        setItem(arr) {
            this.clearItems();
            arr.forEach((x) => {
                this.addItem({ id: x.id, text: x.text });
            })
        }
    }
}